import { Form } from 'antd';

const { useForm } = Form;

export { useForm };
